// extracted by mini-css-extract-plugin
export var footerIdentity = "footer-module--footerIdentity--p4AzA";
export var footerShell = "footer-module--footerShell--9Db-3";
export var footerSocialAction = "footer-module--footerSocialAction--z6u22";
export var footerSocials = "footer-module--footerSocials--aQhed";
export var visitorMap = "footer-module--visitorMap--RhyX7";